export const followsCategoriesIds = {
  applications: 'applications',
}

export const followsCategoriesDefs = {
  [followsCategoriesIds.applications]: {
    title: 'Application',
  },
}
